const isMissingExpenseOrInvoice = (
  ecritureLines
) => {

  for (const ecritureLine of ecritureLines) {
    if (ecritureLine.advancePayment !== true && ecritureLine.labelLettrage === "" && ecritureLine.category &&
      (
        ecritureLine.category.categoryFamily.supplierCategoryForEcriture === true ||
        ecritureLine.category.categoryFamily.clientCategoryForEcriture === true ||
        ecritureLine.category.categoryFamily.collaboratorCategoryForEcriture === true
      )
    ) {
      if ( ecritureLine.tiers) {
        return ecritureLine;
      }
      return null;
    }
  }
  return null;
};

export default isMissingExpenseOrInvoice;
